module.exports = __webpack_public_path__ + "static/img/苹果 Apple MacBookPro M4.32f7e063.png";